import React, { useState } from "react";
import { CaratClosedIcon } from "../controls/ThermalHeatMapSvgs";
import { formatTemp } from "../../hooks/ThermalHeatMapHooks";
import { FaceSummary } from "./ThermalHeatMapSummary";
import CustomToolTip from "../../../../../../../CommonComponents/CustomToolTip";

export interface PerFaceSectionProps {
  summary: FaceSummary[];
  internalSummary: FaceSummary[];
  defaultOpen?: boolean;
}

const PerFaceSection: React.FC<PerFaceSectionProps> = ({
  summary,
  internalSummary,
  defaultOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="thermal-heatmap-summary-box">
      <div className="thermal-heatmap-summary-header-row" onClick={() => setIsOpen((v) => !v)}>
        <button className="thm-summary-toggle-btn">
          <span
            style={{
              display: "flex",
              transform: isOpen ? "rotate(90deg)" : "rotate(0deg)",
              transition: "transform 300ms ease",
            }}
          >
            <CaratClosedIcon active={isOpen} />
          </span>
        </button>
        <div className="thermal-heatmap-summary-header">PER FACE</div>
      </div>
      {isOpen && (
        <div className="thermal-heatmap-face-summary-box">
          <div className="thermal-heatmap-face-summary-grid">
            {summary.map((s) => (
              <div key={s.face} className="thermal-heatmap-face-summary-item">
                <span className="thermal-heatmap-face-summary-label">{s.label}</span>
                <div className="thermal-heatmap-face-summary-values">
                  <CustomToolTip title="Max temperature over full simulation" placement="top">
                    <span className="thermal-heatmap-face-summary-max">
                      {formatTemp(s.max)}
                    </span>
                  </CustomToolTip>
                  <span className="thermal-heatmap-face-summary-sep">/</span>
                  <CustomToolTip title="Min temperature over full simulation" placement="top">
                    <span className="thermal-heatmap-face-summary-min">
                      {formatTemp(s.min)}
                    </span>
                  </CustomToolTip>
                </div>
              </div>
            ))}
            {internalSummary.map((s) => (
              <div key={s.face} className="thermal-heatmap-face-summary-item">
                <span className="thermal-heatmap-face-summary-label">{s.label}</span>
                <div className="thermal-heatmap-face-summary-values">
                  <CustomToolTip title="Max temperature over full simulation" placement="top">
                    <span className="thermal-heatmap-face-summary-max">
                      {formatTemp(s.max)}
                    </span>
                  </CustomToolTip>
                  <span className="thermal-heatmap-face-summary-sep">/</span>
                  <CustomToolTip title="Min temperature over full simulation" placement="top">
                    <span className="thermal-heatmap-face-summary-min">
                      {formatTemp(s.min)}
                    </span>
                  </CustomToolTip>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(PerFaceSection);
